import React, { Component, Fragment } from 'react';
import { Table, Button, Icon, Popconfirm } from 'antd';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { getVideos, deleteVideo } from '../../../../actions';

import VideoModal from './VideoModal';

function truncate(str, n) {
  return (str.length > n) ? `${str.substr(0, n - 1)}...` : str;
}

const BottomWrap = styled.div`
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
`;

class Videos extends Component {
  state = {
    showModal: false,
    selected: null,
  }

  componentDidMount() {
    this.props.getVideos();
  }

  closeModal = () => this.setState({
    showModal: false,
    selected: null,
  })

  showEdit = (record) => this.setState({
    showModal: true,
    selected: record,
  })

  handleDelete = (record) => {
    const { deleteVideo } = this.props;
    deleteVideo({ _id: record._id });
  }

  render() {
    const { showModal, selected } = this.state;
    const { list, loading } = this.props;

    return (
      <Fragment>
        <BottomWrap>
          <Button onClick={() => this.setState({ showModal: true })} type="primary">
            <Icon type="plus" />Thêm video
          </Button>
        </BottomWrap>
      
        <Table
          loading={loading}
          dataSource={list} columns={[
            {
              title: 'Thumbnail',
              dataIndex: 'thumbnail',
              key: 'thumbnail',
              render: (data) => <img src={data} alt="thumbnail" style={{ width: 160 / 2, height: 90 / 2, borderRadius: 4 }} />,
            },
            {
              title: 'Tiêu đề',
              dataIndex: 'title',
              key: 'title',
              render: (data) => <span>{truncate(data[0].value, 50)}</span>,
            },
            {
              title: 'Tuỳ chỉnh',
              key: 'action',
              render: (_, record) => (<span>
                <a onClick={() => this.showEdit(record)}>Sửa</a> · <Popconfirm
                  title="Xác nhận xoá video này?"
                  onConfirm={() => this.handleDelete(record)}
                  okText="Yes"
                  cancelText="No"
                ><a>Xoá</a></Popconfirm>
              </span>),
            },
          ]} rowKey="_id"
        />
        
        <BottomWrap>
          <Button onClick={() => this.setState({ showModal: true })} type="primary">
            <Icon type="plus" />Thêm video
          </Button>
        </BottomWrap>
        
        <VideoModal visible={showModal} onCancel={this.closeModal} initialValue={selected} />
        
      </Fragment>
    );
  }
}

export default connect(state => ({
  list: state.video.list,
  total: state.video.total,
  loading: state.video.loading,
}), {
  getVideos,
  deleteVideo,
})(Videos);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Videos/Videos.js